'use client';

import styles from './FormLabel.module.scss';

type Props = {
  children: React.ReactNode;
  showRequiredMark?: boolean;
};

function FormLabel({ children, showRequiredMark = false }: Props) {
  // クラス名を決定
  const componentStyle = styles.componentStyle;
  const requiredMarkStyle = styles.requiredMark;

  return (
    <div className={componentStyle}>
      {/* biome-ignore lint/a11y/noLabelWithoutControl: <explanation> */}
      <label>
        {children}
        {showRequiredMark && <span className={requiredMarkStyle}>*</span>}
      </label>
    </div>
  );
}

export default FormLabel;
